import { ComponentValidator } from './validators/Component';

import components from './validators/components/all';

import type { ComponentType } from './validators/fields/ComponentType';

const getComponentValidator = (type: ComponentType) => {
    return components[type]?.validators.component ?? ComponentValidator;
};

const getComponentValidatorBulkUploadValidator = (type: ComponentType) => {
    return components[type]?.validators.component;
};

export { getComponentValidator, getComponentValidatorBulkUploadValidator };
